import { inject, Injectable } from '@angular/core';
import { PaymentMethodService, SqliteService } from '@app/services';
import { PaymentMethodModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class PaymentMethodRepository
{
    private readonly keys = {
        tableName: 'payment_methods',
    };
    private sqliteService = inject(SqliteService);
    private paymentMethodService = inject(PaymentMethodService);

    async getPaymentMethods(): Promise<PaymentMethodModel[]>
    {
        const sql = `
            SELECT *
            FROM ${this.keys.tableName};
        `;

        const data = await this.sqliteService.get(sql) ?? [];

        return data as PaymentMethodModel[];
    }

    async downloadPaymentMethods(): Promise<PaymentMethodModel[]>
    {
        const paymentMethods = await this.paymentMethodService.getPaymentMethods();

        if (paymentMethods.length > 0)
        {
            await this.savePaymentMethods(paymentMethods);
        }

        return paymentMethods;
    }

    async savePaymentMethods(paymentMethods: PaymentMethodModel[]): Promise<void>
    {
        const columns = [
            'id',
            'external_id',
            'name',
            'is_payment_reference_required',
        ];
        const batchSize = Math.floor(3000 / columns.length);

        for (let i = 0; i < paymentMethods.length; i += batchSize)
        {
            const chunk = paymentMethods.slice(i, i + batchSize);
            const valuePlaceholders = this.sqliteService.getValuePlaceholder(chunk.length, columns.length);
            const sql = `
                INSERT INTO ${this.keys.tableName} (${columns.join(', ')})
                VALUES ${valuePlaceholders} ON CONFLICT(id) DO
                UPDATE
                    SET
                        external_id = excluded.external_id,
                    is_payment_reference_required = excluded.is_payment_reference_required,
                    name = excluded.name;
            `;
            const values = chunk.flatMap((r) => [
                r.id,
                r.external_id,
                r.name,
                r.is_payment_reference_required ? 1 : 0,
            ]);
            await this.sqliteService.save(sql, values);
        }
    }
}
